/** 
 * Brightcove Learning Services Module
 */
var SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};

(function (bc, $) {
    bc.init = function () {
        initVideo($('.brightcove-wrapper video.video-js'));
        initVideo($('.brightcove-wrapper-audio video.video-js'));
    };

    function initVideo($brightcoveVideo) {
        if ($brightcoveVideo.length) {
            $brightcoveVideo.each(function () {
                var $this = $(this);
                // characters like "/" are not supporded by Brightcove js. URI encoding added to fix that.
                $this.attr('data-video-id', encodeURIComponent($this.attr('data-video-id')).replace('ref%3A', 'ref:'));
            });

            var playerId = $brightcoveVideo.data('player');
            var account = $brightcoveVideo.data('account');
            var jsSrc = '//players.brightcove.net/' + account + '/' + playerId + '_default/index.min.js';
            // load JS only if video exists on page
            $.getScript(jsSrc, function () {
            });
        }
    }
})(SCM.Utilities.Brightcove = SCM.Utilities.Brightcove || {}, jQuery);
